"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.answerViewModel = answerViewModel;
function answerViewModel(answer, setAnswer) {
    return {
        answer,
        setAnswer,
    };
}
